<script setup>
import { Loc } from 'main.core';
import { computed } from 'ui.vue3';
import { storeToRefs } from 'ui.vue3.pinia';
import CalculatorParam from './CalculatorParam.vue';
import InfoBlock from './InfoBlock.vue';
import NumberInput from './NumberInput.vue';
import useCalculatorStore from '../store/calculator.js';

const calculator = useCalculatorStore();
const { selectedGroup, tariff } = storeToRefs(calculator);

const info = computed(() => {
  let info = '';
  const group = tariff.value?.groups.find(g => g.group_id === selectedGroup.value?.id);
  if (tariff.value?.included_users > 0) {
    info = Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_INFO_USERS_INCLUDED', {
      '#AMOUNT#': tariff.value.included_users,
    });
    if (group && group.price_per_user) {
      info += Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_INFO_USERS_ADDITIONAL', {
        '#PRICE#': Intl.NumberFormat().format(group.price_per_user),
      });
    }
  } else if (group && group.price_per_user) {
    info = Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_INFO_USERS_PRICE', {
      '#PRICE#': Intl.NumberFormat().format(group.price_per_user),
    });
  }
  return info;
});
</script>

<template>
  <CalculatorParam>
    <template #title>
      {{ Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_PARAMS_USERS') }}
    </template>
    <template #subtitle>
      {{ Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_PARAMS_USERS_HINT') }}
    </template>
    <NumberInput
      v-model.number="calculator.selectedUsers"
      :label="Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_LABEL_USERS')"
    />
    <template #information>
      <InfoBlock v-if="info" :modifiers="['mark', 'info']">
        {{ info }}
      </InfoBlock>
    </template>
  </CalculatorParam>
</template>
